module.exports = __webpack_public_path__ + "static/media/Recipes.785775ca.png";